// src/components/documentos/TemplatePreviewModal.jsx

import React, { useEffect } from "react";
import Modal from "react-modal";
import { X } from "lucide-react";
import { getTemplateById } from "../../templates/index";
import { MOCK_DATA as TechBlueMock } from "../../templates/cotizacion/TechBlue";

// Mock data por plantilla para el modal
// Cuando agregues más plantillas, importa su MOCK_DATA aquí
const MOCK_BY_ID = {
  "cotizacion-tech-blue": TechBlueMock,
  // "cotizacion-corporativa": CorporativaMock,
};

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1005,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  content: {
    position: "relative",
    inset: "unset",
    width: "100%",
    maxWidth: "860px",
    maxHeight: "90vh",
    borderRadius: "16px",
    border: "none",
    padding: "0",
    overflow: "hidden",
    boxShadow: "0 24px 60px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter, sans-serif",
  },
};

export default function TemplatePreviewModal({
  isOpen,
  templateId,
  activeId,
  onClose,
  onSelect,
}) {
  const template = templateId ? getTemplateById(templateId) : null;
  const isActive = templateId === activeId;
  const TemplateComponent = template?.component;
  const mockData = templateId ? MOCK_BY_ID[templateId] : null;

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleSelect = () => {
    onSelect(template.id);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      closeTimeoutMS={150}
      contentLabel="Vista previa de plantilla"
    >
      {template && (
        <>
          {/* ── Header ── */}
          <div style={s.header}>
            <div>
              <h3 style={s.title}>{template.name}</h3>
              <p style={s.subtitle}>Vista previa de la plantilla</p>
            </div>
            <button style={s.closeBtn} onClick={onClose} title="Cerrar">
              <X size={18} />
            </button>
          </div>

          {/* ── Body scrollable ── */}
          <div style={s.body}>
            <div style={s.previewWrapper}>
              {TemplateComponent && mockData ? (
                /* Componente real a escala completa */
                <div style={s.previewInner}>
                  <TemplateComponent data={mockData} />
                </div>
              ) : (
                <div style={s.noPreview}>
                  <p style={{ color: "#9CA3AF", fontSize: "14px" }}>
                    Vista previa no disponible aún para esta plantilla.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* ── Footer ── */}
          <div style={s.footer}>
            <button style={s.cancelBtn} onClick={onClose}>
              Cerrar
            </button>
            {isActive ? (
              <span style={s.activeLabel}>✓ Plantilla activa</span>
            ) : (
              <button style={s.primaryBtn} onClick={handleSelect}>
                Usar esta plantilla
              </button>
            )}
          </div>
        </>
      )}
    </Modal>
  );
}

const s = {
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "20px 24px 16px",
    borderBottom: "1px solid #F3F4F6",
    flexShrink: 0,
    background: "#ffffff",
  },
  title: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 4px",
  },
  subtitle: { fontSize: "13px", color: "#6B7280", margin: 0 },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    border: "1.5px solid #E5E7EB",
    borderRadius: "8px",
    background: "transparent",
    color: "#6B7280",
    cursor: "pointer",
    flexShrink: 0,
  },
  body: {
    flex: 1,
    overflowY: "auto",
    padding: "24px",
    background: "#F1F5F9",
  },
  previewWrapper: {
    background: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  previewInner: {
    zoom: 0.85,
    pointerEvents: "none",
  },
  noPreview: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "16px 24px",
    borderTop: "1px solid #F3F4F6",
    flexShrink: 0,
    background: "#ffffff",
  },
  cancelBtn: {
    background: "transparent",
    border: "1.5px solid #E5E7EB",
    borderRadius: "8px",
    padding: "8px 20px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#374151",
    cursor: "pointer",
  },
  primaryBtn: {
    background: "#3B82F6",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "8px 20px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
  },
  activeLabel: { fontSize: "13px", fontWeight: 500, color: "#3B82F6" },
};
